import { createStore } from 'vuex'
import { distributorModule } from './modules/distributor.module'
import { affiliateModule } from './modules/affiliate.module'
import { accountModule } from './modules/account.module'
import { authModule } from './modules/auth.module'
import { authorizationModule } from './modules/authorization.module'
import { beneficiaryModule } from './modules/beneficiary.module'
import { cardModule } from './modules/card.module'
import { clearingModule } from './modules/clearing.module'
import { orderModule } from './modules/order.module'
import { paramModule } from './modules/param.module'
import { productModule } from './modules/product.module'
import { profileModule } from './modules/profile.module'
import { userModule } from './modules/user.module'
import { operationModule } from './modules/operation.module'
import { requestModule } from './modules/request.module'

export default createStore({
  modules: {
    affiliates: affiliateModule,
    accounts: accountModule,
    auth: authModule,
    authorizations: authorizationModule,
    beneficiaries: beneficiaryModule,
    cards: cardModule,
    clearings: clearingModule,
    distributors: distributorModule,
    orders: orderModule,
    operations: operationModule,
    params: paramModule,
    products: productModule,
    profiles: profileModule,
    users: userModule,
    requests: requestModule
  }
})
